import { create } from "zustand";
import { ChatHistoryResponse, getUserHistory, getUserHistoryById, changeHistory } from "../../api";
import { HistoryStore } from "../types";
import { persistStore } from "../store";

const getTodayHistoryKey = () => new Intl.DateTimeFormat("en-GB").format(new Date()).replace(/\//g, ".");

const hasChatId = (items: Record<string, ChatHistoryResponse[]>, chatId: string) => {
    return Object.values(items).some((records) => records.some((record) => record.chat_id === chatId));
};

export const useHistoryStore = create<HistoryStore>((set, get) => ({
    items: undefined,
    favorites: [],
    openedItem: "",
    addItem: (item: ChatHistoryResponse) => {
        if (!item.chat_id) {
            return;
        }

        const currentItems = get().items ?? {};
        if (hasChatId(currentItems, item.chat_id)) {
            return;
        }

        const todayKey = getTodayHistoryKey();
        const todayItems = currentItems[todayKey] ?? [];

        set({
            items: {
                [todayKey]: [...todayItems, item],
                ...Object.fromEntries(Object.entries(currentItems).filter(([key]) => key !== todayKey)),
            }
        });
    },
    changeItem: async (chat_id: string, status: string) => {
        const data = get().items;
        for (const date in data) {
            data[date].forEach((chat: ChatHistoryResponse) => {
                if (chat.RowKey === chat_id) {
                    chat.status = status;
                }
            });
        }
        set({ items: data });

        if (status === "favorite") {
            set({ favorites: [...get().favorites, chat_id] });
        } else if (status === "active") {
            set({ favorites: get().favorites.filter((item) => item !== chat_id) });
        } else {
            set({ favorites: get().favorites.filter((item) => item !== chat_id) });
        }
        await changeHistory({ rowkey: chat_id, status });

    },
    init: async (token: string) => {
        const data = await (token === "" ? getUserHistoryById(persistStore.getState().userId) : getUserHistory());
        if (data !== undefined && data !== null) {
            set({ items: data, favorites: Object.values(data).flat().filter(item => item.status === "favorite").map(item => item.RowKey) });
        }
    },
    changeOpenned: (chat_id: string) => {
        set({ openedItem: chat_id });
    },
    getChatIDs: () => {
        const data = get().items;
        const ids: string[] = [];
        for (const date in data) {
            data[date].forEach((chat: ChatHistoryResponse) => {
                ids.push(chat.chat_id);
            });
        }
        return ids;
    }
}));
